import { useState, type FC } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { usePermissionsQuery } from '../../queries'
import type {
  PermissionsLoaderProps,
  ReactQueryProviderProps
} from './react-query-provider.types'

const STALE_TIME = 2 * 60 * 1000 // 2 minutos
const GC_TIME = 5 * 60 * 1000 // 5 minutos

const makeQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
        retry: 1,
        refetchOnWindowFocus: false
      }
    }
  })

const PermissionsLoader: FC<PermissionsLoaderProps> = ({
  httpClient,
  children
}) => {
  usePermissionsQuery(httpClient)

  return children
}

const ReactQueryProvider: FC<ReactQueryProviderProps> = ({
  httpClient,
  children
}) => {
  const [queryClient] = useState(makeQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <PermissionsLoader httpClient={httpClient}>
        {children}
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </PermissionsLoader>
    </QueryClientProvider>
  )
}

export default ReactQueryProvider
